import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const ITEMS = [
  {
    q: "Is Lychee a marketplace?",
    a: "No. Lychee is a curated, brand-side platform. Creators don't browse jobs or bid — we match your brief with the right people from our reviewed roster.",
  },
  {
    q: "What does a 'visit' actually mean?",
    a: "A creator physically comes to your venue, experiences the brand the way a customer would, and captures it on the ground. They can document the visit (stories, posts) or simply scout for a follow-up shoot.",
  },
  {
    q: "Who owns the content?",
    a: "You do. Every contract includes brand usage rights — duration varies by tier, from 30 days for Shoot-only to perpetual for full sponsorship campaigns.",
  },
  {
    q: "Which cities do you cover?",
    a: "We're on-ground across the MENA region and South Asia — including the UAE, Saudi Arabia, Qatar, Kuwait, Bahrain, Oman, Egypt, Jordan, Lebanon, Morocco, Türkiye and Pakistan. New cities open based on demand — mention your city when booking a consultation.",
  },
  {
    q: "How much does it cost?",
    a: "Pricing is contract-based and depends on creator tier, deliverables, and usage rights. Brands in our beta typically spend between $400 and $8,000 per campaign.",
  },
  {
    q: "How do I get started?",
    a: "Book a free 20-minute consultation through the form below. We'll understand your brand, recommend the right contract tier, and shortlist 3–5 creators in your city — usually within 1 business day.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <p className="text-xs uppercase tracking-[0.22em] text-[#276152] font-semibold">
            FAQ
          </p>
          <h2 className="font-serif text-5xl sm:text-6xl leading-[0.95] mt-4 text-[#0D3A35]">
            Questions, <br />
            <span className="text-[#276152]">answered.</span>
          </h2>
          <p className="mt-6 text-sm text-[#0D3A35]/70 max-w-sm">
            Still curious? Drop us a note via the consultation form — we read
            every single one.
          </p>
        </div>
        <div className="lg:col-span-7 lg:col-start-6">
          <Accordion type="single" collapsible className="w-full">
            {ITEMS.map((item, i) => (
              <AccordionItem
                key={item.q}
                value={`item-${i}`}
                className="border-b border-[#B1B7AB]/50 last:border-b-0"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="font-serif text-xl sm:text-2xl text-[#0D3A35] py-6 hover:no-underline text-left">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-base leading-relaxed text-[#0D3A35]/75 pb-6 pr-6">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
